export default "__VITE_ASSET__BXqYf$aW__"